import React, { useState } from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  HStack,
  VStack,
  Text,
  Image,
  Stack,
  Button,
} from "@chakra-ui/react";
import { BlackCarIcon } from "../../../icons/BlackCarIcon";
import { useNavigate } from "react-router-dom";
export const Slider = () => {
  const items = [
    {
      title: "Digitalizá tus viajes",
      description:
        "Si manejás un taxi, remis o un auto particular, descargá la app para empezar a recibir viajes. Podés consultar los recorridos antes de aceptarlos, planificar viajes y consultar las zonas de mayor demanda",
    },
    {
      title: "Ganá más, ofrecé mejor",
      description:
        "Promocioná los servicios que podés brindarle a tus pasajeros para que conozcan todas las comodidades. Cuanta más info ofrezcas, más visibilidad tendrás en la app",
    },
    {
      title: "Aprovechá tu tiempo",
      description:
        "Planificá tu jornada tomando viajes programados por los pasajeros o salí a recorrer las calles. Podés tomar viajes en el momento o asegurar el flujo constante de pasajeros tomando viajes reservados.",
    },
    {
      title: "Cobrá online o en efectivo",
      description:
        "Podés elegir el método de pago que querés recibir y hacer match con los pasajeros que coinciden en tus preferencias. En efectivo, con tarjeta o con billeteras virtuales, seleccioná el método que te haga sentir más seguro",
    },
  ];

  const images = [
    "/sliderImages/first.png",
    "/sliderImages/second.png",
    "/sliderImages/third.png",
    "/sliderImages/fourth.png",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleTabsChange = (index: number) => {
    setCurrentIndex(index);
  };

  const navigate = useNavigate();

  return (
    <Stack
      flexDirection={["column", "column", "row"]}
      bgColor="primary.900"
      rounded="xl"
      w="80%"
      px={[8, 8, 20]}
      py={[6, 6, 12]}
      pb={["100px", "100px", "0"]}
      mt={"100px"}
      justifyContent="space-between"
      alignItems="center"
      position="relative"
      id="driver"
    >
      <VStack w={['100%', '100%', '50%']}
        alignItems="stretch"
        gap={10} >
        <Text
          bgColor="primary.800"
          size="xs"
          color="white"
          rounded="md"
          fontSize="small"
          fontWeight="semibold"
          py={2}
          px={2}
          userSelect="none"
        >
          Quiero conducir
        </Text>
        <Tabs
          variant="unstyled"
          index={currentIndex}
          onChange={handleTabsChange}
          w="100%"
        >
          <TabList gap={2} w="100%">
            <Tab
              w="25%"
              rounded="full"
              h="6px"
              p={0}
              bgColor={"primary.700"}
              _selected={{ bgColor: "primary.200" }}
            />
            <Tab
              w="25%"
              rounded="full"
              h="6px"
              p={0}
              bgColor={"primary.700"}
              _selected={{ bgColor: "primary.200" }}
            />
            <Tab
              w="25%"
              rounded="full"
              h="6px"
              p={0}
              bgColor={"primary.700"}
              _selected={{ bgColor: "primary.200" }}
            />
            <Tab
              w="25%"
              rounded="full"
              h="6px"
              p={0}
              bgColor={"primary.700"}
              _selected={{ bgColor: "primary.200" }}
            />
          </TabList>
          <TabPanels mt={10} w="80%">
            {items.map((item, index) => (
              <TabPanel key={index} p={0}>
                <Text lineHeight="unset" fontSize={['24px', '24px', "32px"]} fontWeight="bold" color='#fff'>
                  {item.title}
                </Text>
                <Text
                  lineHeight="unset"
                  color="primary.500"
                  fontSize="18px"
                  mt="8px"
                >
                  {item.description}
                </Text>
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
        <Button
          bgColor="white"
          size="md"
          color="primary.800"
          rounded="md"
          fontWeight="semibold"
          fontSize={['sm', 'md', 'md']}
          py={[3, 4, 5]}
          px={[6, 10, 12]}
          w={['full', 'auto', 'auto']}
          alignSelf={['flex-start', 'flex-end', 'flex-end']}
          onClick={() => navigate('/driver-form')}
        >
          Registrarme
        </Button>
      </VStack>
      <HStack w={['80%', '80%', '50%']} mt={[44, 44, 0]} maxH={['800px', '800px', '480px']} justifyContent='flex-end'>
        <Image src={images[currentIndex]} transform={['scale(1.5)', 'scale(1.5)', "scale(.70)"]} />
      </HStack>
      <HStack position="absolute" bottom={-8} left={0} w="full" px={20}>
        <BlackCarIcon ml={-2} h={100} w={100} />
      </HStack>
    </Stack>
  );
};
